module.exports = __webpack_public_path__ + "img/ic-notification.026bfc6b.svg";